module.exports = __webpack_public_path__ + "img/MSPNG2_Cover.9721cc15.jpg";